module.exports = __webpack_public_path__ + "img/blog-47.43b652bf.jpg";